import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { FieldRow, FieldViewValue } from '@/components/layout/field-row'

interface ProviderFieldProps {
  children: ReactNode
  isEditing: boolean
  label: string
  locked?: boolean
  required?: boolean
  view?: ReactNode
}

// Note: a locked field is never editable and always shows its value, an unlocked one is an input
// while editing and its value otherwise
export const ProviderField = ({
  children,
  isEditing,
  label,
  locked,
  required,
  view,
}: ProviderFieldProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <FieldRow
      hint={locked ? t('organisation:places.accessControl.credentials.lockedNote') : undefined}
      label={label}
      locked={locked}
      required={required && isEditing && !locked}
    >
      {isEditing && !locked ? children : <FieldViewValue>{view}</FieldViewValue>}
    </FieldRow>
  )
}
